import { defineMessages } from 'react-intl-next';

export const i18n: {
    contentTabLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; generalTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; layoutsTitle: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preamble: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preambleSupportLinkLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; preambleWithoutSupportLink: {
        defaultMessage: string;
        description: string;
        id: string;
    }; stylesTabLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; title: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	title: {
		id: 'company-hub.spotlight-extension.config-panel.title',
		defaultMessage: 'Spotlight',
		description: 'A visible text label to be used as the title for the spotlight extension config panel',
	},
	preamble: {
		id: 'company-hub.spotlight-extension.config-panel.preamble',
		defaultMessage: 'Highlight important messages with a visual spotlight. {supportLink}',
		description: 'A visible text label to be used as the preamble for the spotlight extension config panel',
	},
	preambleWithoutSupportLink: {
		id: 'company-hub.spotlight-extension.config-panel.preamble-without-support-link',
		defaultMessage: 'Highlight important messages with a visual spotlight.',
		description:
			'A visible text label to be used as the preamble for the spotlight extension config panel wihout a support link',
	},
	preambleSupportLinkLabel: {
		id: 'company-hub.spotlight-extension.config-panel.preamble-link.label',
		defaultMessage: 'Learn more about spotlights',
		description:
			'A visible text label to be used as a link to a support page in the preamble of the Spotlight extension config panel',
	},
	stylesTabLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.styles-tab.label',
		defaultMessage: 'Styles',
		description: 'Styles tab pill label in the spotlight extension config panel. Selected by default',
	},
	contentTabLabel: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.content-tab.label',
		defaultMessage: 'Content',
		description: 'Content tab pill label in the spotlight extension config panel',
	},
	generalTitle: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.general-title',
		defaultMessage: 'General',
		description: 'General section title in the spotlight extension config panel. This a collapsible  button that opens and closes the General section',
	},
	layoutsTitle: {
		id: 'company-hub.spotlight-extension.spotlight-config-panel.layouts-title',
		defaultMessage: 'Layouts',
		description: 'Layouts section title in the spotlight extension config panel. This a collapsible  button that opens and closes the General section',
	},
});
